import { css } from 'styled-components';

export default css`
  display: flex;
  ${props => (props.isMobile ? '' : 'height: 100%;')}
  padding: 5px 10px;

  @media (max-width: 950px) {
    padding: 10px;
  }
`;
